import MainNavigation from './main-navigation';
import MobileMenu from './mobile-menu';
import ScrollToTop from './scroll-to-top';

const nav = new MainNavigation(document.querySelector('#main-navigation'));
if (nav._root) nav.setActiveState();

new MobileMenu(document.querySelector('.header'));
new ScrollToTop(document.querySelector('.scroll-to-top'));
